module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_redefine.js
// module id = 211
// module chunks = 16